import { getViewport } from '../core/global';
import {UcoastEl} from "@/scripts/core/UcoastEl";

export class ProductTabs extends UcoastEl {
	static htmlSelector = 'product-tabs';
	constructor() {
		super();
		this.navItems = this.querySelectorAll('[data-tab-nav]');
		this.navContainer = this.querySelector('[data-tab-nav-container]');
		this.mobileNavItems = this.querySelectorAll('[data-tab-mobile-nav]');
		this.contentItems = this.querySelectorAll('[data-tab-content]');
		this.contentContainer = this.querySelector('[data-tabs-container]');
		this.activeBg = this.querySelector('[data-tab-active-bg]');
		this.setBluebird = false;
		this.bluebirdLoaded = false;

		if (!this.navItems || !this.contentItems) return;

		this.initItems();
		const resizeObserver = new ResizeObserver((entries) => this.initItems());
		resizeObserver.observe(this.contentContainer);

		for (let i = 0; i < this.navItems.length; i++) {
			this.navItems[i].addEventListener('click', this.onButtonClick.bind(this));
			this.mobileNavItems[i].addEventListener('click', this.onButtonClick.bind(this));
		}
	}

	initItems() {
		this.classList.add('loaded');
		this.setHeight();
	}

	setHeight() {
		const { contentItem, navItem } = this.getActiveItem();
		if (getViewport() === 'm-up') {
			this.classList.add('loaded');
			this.contentContainer.style.height = `${contentItem.offsetHeight}px`;

			const leftDistance = navItem.getBoundingClientRect().left - this.navContainer.getBoundingClientRect().left;
			this.activeBg.style.width = `${navItem.offsetWidth}px`;
			this.activeBg.style.transform = `translateX(${leftDistance}px)`;
			contentItem.removeAttribute('style');
		} else {
			this.contentContainer.style.height = 'unset';
			contentItem.style.maxHeight = `${contentItem.scrollHeight}px`;
		}
	}

	getTab(el) {
		return el.getAttribute('data-tab');
	}

	getSelectedItem(i) {
		return {
			navItem: this.navItems[i],
			contentItem: this.contentItems[i],
			mobileNavItem: this.mobileNavItems[i],
		};
	}

	getActiveItem() {
		let activeItem = this.getSelectedItem(0);
		[].forEach.call(this.navItems, (el, i) => {
			if (el.getAttribute('aria-current') !== 'true') return;
			activeItem = this.getSelectedItem(i);
		});
		return activeItem;
	}

	setActive(item) {
		item.navItem.setAttribute('aria-current', 'true');
		item.contentItem.setAttribute('aria-expanded', 'true');
		item.mobileNavItem.setAttribute('aria-current', 'true');
		if (item.contentItem.querySelector('blue-bird') && !this.bluebirdLoaded) {
			this.setBluebird = true;
		}
	}

	setHidden(item) {
		item.navItem.removeAttribute('aria-current');
		item.contentItem.removeAttribute('aria-expanded');
		item.contentItem.removeAttribute('style');
		item.mobileNavItem.removeAttribute('aria-current');
	}

	onButtonClick(event) {
		event.preventDefault();
		const id = this.getTab(event.target) ? this.getTab(event.target) : this.getTab(event.target.parentNode);
		[].forEach.call(this.navItems, (el, i) => {
			const item = this.getSelectedItem(i);
			if (el.getAttribute('data-tab') !== id) {
				this.setHidden(item);
				return;
			}
			this.setActive(item);
		});
		this.setHeight();
		if (this.setBluebird && !this.bluebirdLoaded) {
			this.querySelector('blue-bird').load();
			this.setBluebird = false;
			this.bluebirdLoaded = true;
			console.log('this.bluebirdLoaded', this.bluebirdLoaded);
			this.querySelector('blue-bird').iframe.onload = () => {
				this.setHeight();
			};
		}
	}
}
